import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useRemmitances = () => {

    const createNewRemmitances = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/remmitances/new`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
            body: JSON.stringify(data),
        });


    const result = await response.json();

        if (result?.payload) {
            return result;
        } else {
            return {...result, payload: []};
        }
    }, []);

    const getListOffices = useCallback(async (signal) => {
        const storedData = sessionStorage.getItem('listOffices');   
             
        
        if (storedData) {            
                return JSON.parse(storedData);
        }
    
        const response = await fetch(`${getClientDomain()}/remmitances/offices`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });
    
        const result = await response.json();
        
        if (result?.payload?.length > 0) {
            sessionStorage.setItem('listOffices', JSON.stringify(result.payload));
            return result.payload;
        } else {
            return [];
        }
    }, []);
    
    const getListMethodPayment = useCallback(async (signal) => {
        const storedData = sessionStorage.getItem('listMethodPayment');
        if (storedData) {
            return JSON.parse(storedData);
        }
    
        const response = await fetch(`${getClientDomain()}/remmitances/methodsPayment`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });
    
        const result = await response.json();
        
        if (result?.payload?.length > 0) {
            sessionStorage.setItem('listMethodPayment', JSON.stringify(result.payload));
            return result.payload;
        } else {
            return [];
        }
    }, []);

    const getListStatus = useCallback(async (signal) => {
        const storedData = sessionStorage.getItem('listStatus');
        if (storedData) {
            return JSON.parse(storedData);
        }

        const response = await fetch(`${getClientDomain()}/remmitances/status`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });

        const result = await response.json();

        if (result?.payload?.length > 0) {
            sessionStorage.setItem('listStatus', JSON.stringify(result.payload));
            return result.payload;
        } else {
            return [];
        }
    }, []);

    const getRemmitancesByFilter = useCallback(async (signal, data) => {
    
        const response = await fetch(`${getClientDomain()}/remmitances/search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
            body: JSON.stringify(data),
        });
    
        const result = await response.json();        
        
        if (result?.payload?.length > 0) {
            return result;
        } else {
            return {...result, payload: []};
        }
    }, []);
    
    const confirmDeliverRemittanceById = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/remmitances/confirmDeliver`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
                },
            signal: signal,
            body: JSON.stringify(data),
            });
            const result = await response.json();
            return result;
            }, []);
    
    const getRemittancesInsights = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/remmitances/insights/home`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });

        const result = await response.json();        

        if (result?.payload) {
            return result;
        } else {
            return {...result, payload: {}};
        }
    }, []);

    const getWithdrawnRemittancesYear = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/remmitances/insights/withdrawn/year`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });

        const result = await response.json();

        if (result?.payload) {
            return result;
        } else {
            return {...result, payload: []};
        }
    }, []);

    const getComission = useCallback(async (signal) => {
        const cachedData = sessionStorage.getItem('comission');
        if (cachedData) return JSON.parse(cachedData);
    
        try {
            const response = await fetch(`${getClientDomain()}/remmitances/comission`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal,
            });
    
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
            const { payload = [] } = await response.json();
            sessionStorage.setItem('comission', JSON.stringify(payload));
            return payload;
        } catch (error) {
            console.error('Error fetching comission:', error);
            return [];
        }
    }, []);

    const getListProvinces = useCallback(async (signal) => {
        const storedData = sessionStorage.getItem('listProvinces');
        if (storedData) {
            return JSON.parse(storedData);
        }

        const response = await fetch(`${getClientDomain()}/remmitances/provinces`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });

        const result = await response.json();

        if (result?.payload?.length > 0) {
            sessionStorage.setItem('listProvinces', JSON.stringify(result.payload));
            return result.payload;
        } else {
            return [];
        }
    }, []);
    

    return { createNewRemmitances, getListOffices, getListMethodPayment, getRemmitancesByFilter, confirmDeliverRemittanceById, getRemittancesInsights, getWithdrawnRemittancesYear , getComission, getListStatus, getListProvinces };
}